import { Typography } from "@mui/material";

export function MandatoryIcon() {
  return (
    <Typography
      sx={{
        display: "inline-block",
        color: "red",
        position: "relative",
        top: "-5px",
        left: "3px",
        // Sem isso, o line-height do body2 deixa o rótulo mais alto e desalinha o campo da linha.
        lineHeight: 1,
      }}
      variant="body2"
      // span: dentro de rótulo ou de texto, um <p> gera HTML inválido.
      component="span"
    >
      *
    </Typography>
  );
}
